module.exports = __webpack_public_path__ + "img/clear.2f8b1b44.svg";